import type {BioIconProps} from './common-types'

export function BrgIconArrowForward({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill={fill} xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g id="icon/arrow head/forward">
        <path
          id="arrow_forward_ios"
          d="M4.79177 12.5525L3.80566 11.5664L8.37511 6.99696L3.80566 2.42752L4.79177 1.44141L10.3473 6.99696L4.79177 12.5525Z"
        />
      </g>
    </svg>
  )
}
